import { ACCOUNT_STATUS } from '@/shared/interfaces/gcp/accountStatus.enum';

export const TV_BOX_TYPES_BY_PRODUCT_CODE = [
  { productCode: 'P121276', tvType: 'stream' },
  { productCode: 'P130106', tvType: 'v6' },
  { productCode: 'P118260', tvType: '360' },
  { productCode: 'P118259', tvType: '360' },
  { productCode: 'P105441', tvType: 'tivo' },
];

export const TV_BOX_TYPES = ['v6', '360', 'tivo', 'stream'];

export const BROADBAND_HUB_TYPES = ['hub2', 'hub3', 'hub4', 'hub5', 'hub5x'];

export const ACCOUNT_STATUS_ACTION_CODES = [
  { actionCode: 'C1A', accountStatus: ACCOUNT_STATUS.noPayDisconnect },
  { actionCode: 'D1A', accountStatus: ACCOUNT_STATUS.noPayDisconnect },
  { actionCode: 'X1A', accountStatus: ACCOUNT_STATUS.noPayDisconnect },

  { actionCode: 'C1C', accountStatus: ACCOUNT_STATUS.pendingInstall },
  { actionCode: 'D1B', accountStatus: ACCOUNT_STATUS.pendingInstall },
  { actionCode: 'X1B', accountStatus: ACCOUNT_STATUS.pendingInstall },

  { actionCode: 'C1E', accountStatus: ACCOUNT_STATUS.tempDisconnect },
  { actionCode: 'D1C', accountStatus: ACCOUNT_STATUS.tempDisconnect },
  { actionCode: 'X1C', accountStatus: ACCOUNT_STATUS.tempDisconnect },

  { actionCode: 'C1B', accountStatus: ACCOUNT_STATUS.disconnect },
  { actionCode: 'D1D', accountStatus: ACCOUNT_STATUS.disconnect },
  { actionCode: 'X1D', accountStatus: ACCOUNT_STATUS.disconnect },

  { actionCode: 'C1D', accountStatus: ACCOUNT_STATUS.neverInstall },
  { actionCode: 'D1E', accountStatus: ACCOUNT_STATUS.neverInstall },
  { actionCode: 'X1E', accountStatus: ACCOUNT_STATUS.neverInstall },
];

export const ERROR_ACTION_CODES = ['C0A', 'C0C', 'D0B', 'X0A'];

// Temp mapping from c-app to einstein.
export const CATEGORY_MAPPINGS = [
  { id: '1', name: 'Mobile' },
  { id: '2', name: 'Tablet' },
  { id: '3', name: 'Computer' },
  { id: '4', name: 'Printer' },
  { id: '5', name: 'Entertainment' },
  { id: '6', name: 'Gaming' },
  { id: '7', name: 'Fitness' },
  { id: '8', name: 'Unknown' },
  { id: '18', name: 'Technology' },
  { id: '19', name: 'WiFi equipment' },
  { id: '20', name: 'WiFi equipment' },
  { id: '21', name: 'Unknown' },
  { id: '22', name: 'Smart home' },
  { id: '24', name: 'Entertainment' },
  { id: '25', name: 'Smart home' },
  { id: '26', name: 'WiFi equipment' },
  { id: '27', name: 'Entertainment' },
  { id: '28', name: 'WiFi equipment' },
];
